export const percorsoAttivo = (percorso: string, href: string): boolean =>
  href === '/' ? percorso === '/' : percorso === href || percorso.startsWith(`${href}/`)
